import { LaravelResponse, keyToUrl } from "@dgs/core";
import axios, { AxiosRequestConfig } from "axios";
import { Preference } from "../../types/preference";
import { preferenceKeys } from "./preferenceKeys";

export const preferenceUrls = {
	index: keyToUrl(preferenceKeys.index),
};

const index = (config?: AxiosRequestConfig) => axios.get<LaravelResponse<Preference[]>>(preferenceUrls.index, config);

export const preferenceService = {
	index,
};
